import { clsx } from 'clsx';
import React from 'react';
import HelpLink from '~/components/Links/HelpLink';
import ShieldIcon from '~/public/static/svg/ShieldIcon';

interface Props {
  className?: string;
}

const BuyerProtection: React.FC<Props> = ({ className }) => (
  <div className={clsx('text-center', className)}>
    <HelpLink link="buyerProtection" className="inline">
      <div className="flex items-center justify-center space-x-2 text-xs">
        <ShieldIcon height={30} />

        <div>Shop Safely with SidelineSwap Buyer Protection</div>
      </div>
    </HelpLink>
  </div>
);

export default BuyerProtection;
